<template>
  <div>
    <base-card>
      <div>
        <v-card-title v-if="!cardLoading" class="py-2">
          <v-row class="align-center">
            <!-- Button -->
            <v-col
              cols="12"
              md="6"
              class="py-1"
              v-if="selectedModifierLinkProducts.length > 0"
            >
              <v-btn
                class="mt-n6"
                small
                dark
                color="primary"
                @click="(title = 'Add'), openDialog()"
              >
                <v-icon small>mdi-plus</v-icon>
                Assign Modifier Ingredient
              </v-btn>
            </v-col>

            <!-- Select -->
            <v-col cols="12" md="6" class="py-1">
              <v-select
                v-model="selectBranch"
                :items="branchList"
                item-text="name"
                item-value="branch_id"
                dense
                solo
              ></v-select>
            </v-col>

            <!-- Switch (next row) -->
            <v-col cols="12" class="py-0">
              <v-switch
                class="my-n3"
                v-model="switch1"
                :label="labelText"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8">Modifier</v-col>
            <v-col cols="12" lg="4"
              ><v-text-field
                class="mt-n5"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-if="!cardLoading"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-title>
        <div class="text-center" v-if="cardLoading">
          <v-progress-circular
            class="mb-16"
            :size="40"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-show="!cardLoading">
          <!-- <v-data-table
            :loading="productListLoading"
            :headers="headers"
            :items="modifiers"
            :expanded.sync="expanded"
            show-expand
            :search="search"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="id"
            :single-expand="false"
            class="elevation-1"
          >
            <template v-slot:item.modifier_name="{ item }">
              <strong>{{ item.modifier_name }}</strong>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-simple-table dense>
                  <tbody>
                    <tr v-for="branch in item.branch_links" :key="branch.id">
                      <td class="text-right">
                        <span v-if="branch.assiged == 1">Assiged</span>
                        <v-checkbox
                          v-else
                          v-model="branch.checked"
                          hide-details
                          @change="updateSelected(branch)"
                        ></v-checkbox>
                      </td>
                      <td @click="onExpandedClick(branch.id)">
                        {{ branch.item_name }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </td>
            </template>
          </v-data-table> -->
          <v-data-table
            :loading="productListLoading"
            :headers="headers"
            :items="modifiers"
            :expanded.sync="expanded"
            show-expand
            :search="search"
            item-key="id"
            :single-expand="false"
            mobile-breakpoint="0"
            class="elevation-1 responsive-modifier-table"
          >
            <template v-slot:item.modifier_name="{ item }">
              <span class="text-subtitle-1 font-weight-bold">{{
                item.modifier_name
              }}</span>
            </template>

<template v-slot:expanded-item="{ headers, item }">
  <td :colspan="headers.length" class="pa-0 grey lighten-5">
    <v-simple-table dense class="transparent">
      <tbody>
        <tr v-for="branch in item.branch_links" :key="branch.id" class="child-row">
          
          <td style="width: 65px" class="pl-8">
            <v-chip v-if="branch.assiged == 1" small color="success" label outlined>
              Assigned
            </v-chip>

            <div v-else @click.stop> 
              <v-checkbox
                v-model="branch.checked"
                hide-details
                dense
                class="ma-0 pa-0"
                color="primary"
                @change="updateSelected(branch)"
              ></v-checkbox>
            </div>
          </td>

          <td 
            class="text-body-2 py-2 clickable-item" 
            @click="onExpandedClick(branch.id)"
          >
            {{ branch.item_name }}
          </td>

        </tr>
      </tbody>
    </v-simple-table>
  </td>
</template>
          </v-data-table>
        </div>
      </div>
    </base-card>

    <v-dialog v-model="dialog" width="600">
      <v-card class="pa-4">
        <v-card-text>
          <div class="mb-5">
            <span class="text-h6" v-if="title == 'Add'">
              Assign Modifier Ingredient
            </span>
            <span class="text-h6" v-if="title == 'Edit'"> Edit</span>
          </div>
        </v-card-text>
        <!-- Search Ingredient -->
        <v-text-field
          v-model="searchForIngredient"
          label="Search ingredient"
          prepend-inner-icon="mdi-magnify"
          clearable
        ></v-text-field>

        <v-list v-if="filtered.length > 0">
          <v-list-item
            v-for="item in filtered"
            :key="item.ingredient_company_link_branch_id"
            @click="addIngredient(item)"
            class="cursor-pointer"
            dense
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list v-else>
          <v-list-item>
            <v-list-item-title class="grey--text text-italic">
              No ingredients match your search.
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <!-- Added Ingredients -->
        <div v-for="(ing, i) in addedIngredients" :key="i" class="mb-3">
          <v-row align="center">
            <!-- Ingredient name -->
            <v-col cols="7">
              <v-text-field :value="ing.name" label="Ingredient" readonly />
            </v-col>

            <!-- Unit used field -->
            <v-col cols="3">
              <v-text-field
                v-model="ing.unit_used"
                label="Unit Amount"
                :suffix="ing.unit == 'each' ? 'unit' : ing.unit"
              />
            </v-col>

            <!-- Remove Button -->
            <v-col cols="2" class="text-center">
              <v-btn icon @click="remove(i)">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- Save Button -->
        <v-btn
          color="success"
          large
          :loading="saveBtnLoading"
          block
          class="mt-6"
          @click="dialogAction()"
        >
          SAVE
        </v-btn>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    selectedIngredient: { required },
  },
  data() {
    return {
      domain: BASEURL,
      syncDomain: BASESYNCURL,

      modifierList: [],
      modifiers: [],
      productListLoading: false,
      headers: [
        { text: "Modifier", value: "modifier_name" },
        { text: "", value: "data-table-expand" },
      ],
      selectedModifierLinkProducts: [],
      expanded: [],
      switch1: false,
      labelText: "",
      searchForIngredient: "",
      ingredients: [],
      addedIngredients: [],
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
      companyID: "",
      branchList: [],
      editBranchLinkModifier: "",
      saveBtnLoading: false,
      dialog: false,
      title: "",
      selectBranch: "",
      cardLoading: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      selectedIngredient: "",
    };
  },

  watch: {
    selectBranch() {
      this.getAllModifier();
      this.getAllBranchIngredient();
    },
    switch1() {
      if (this.switch1) {
        this.labelText = "Shrink all";
        this.expanded = this.modifiers;
      } else {
        this.labelText = "Expand All";
        this.expanded = [];
      }
    },
  },

  computed: {
    filtered() {
      const search = String(this.searchForIngredient || "")
        .toLowerCase()
        .trim();

      if (!search) {
        return this.ingredients;
      }

      return this.ingredients.filter((item) =>
        String(item.name || "")
          .toLowerCase()
          .includes(search)
      );
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
  },

  methods: {
    getAllModifier() {
      this.productListLoading = true;
      const params = new URLSearchParams();
      params.append("getAllModifierForIngredient", "done");
      params.append("branch_id", this.selectBranch);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.modifierList = response.data.product;
            this.modifiers = this.modifierList.map((item) => ({
              id: item.modifier.mod_group_id,
              modifier_name: item.modifier.name,

              branch_links: item.modifier_branch_item.map((b) => ({
                id: b.branch_link_modifier_id,
                item_name: b.item_name,
                mod_item_id: b.mod_item_id,
                checked: b.Checked,
                assiged: b.Checked == 1 ? 1 : 0,
              })),
            }));

            if (this.switch1) {
              this.labelText = "Shrink all";
              this.expanded = this.modifiers;
            } else {
              this.labelText = "Expand All";
              this.expanded = [];
            }

            this.cardLoading = false;
            this.productListLoading = false;
          } else {
            this.modifierList = [];
            this.modifiers = [];
            this.cardLoading = false;
            this.productListLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateSelected(branch) {
      const id = branch.id;

      if (branch.checked) {
        // Add only the branch_link_product ID
        if (!this.selectedModifierLinkProducts.includes(id)) {
          this.selectedModifierLinkProducts.push(id);
        }
      } else {
        // Remove if unchecked
        this.selectedModifierLinkProducts =
          this.selectedModifierLinkProducts.filter((x) => x !== id);
      }

      console.log(
        "Selected branch_link_product IDs:",
        this.selectedModifierLinkProducts
      );
    },

    addIngredient(item) {
      const exists = this.addedIngredients.some(
        (ing) => parseInt(ing.id) === item.ingredient_company_link_branch_id
      );

      if (exists) {
        // Optional: show message
        this.text = "ingredient already added in list";
        this.snackbar = true;
        this.snackbarColor = "error";
        return;
      }

      this.addedIngredients.push({
        id: item.ingredient_company_link_branch_id,
        name: item.name,
        unit_used: 0,
        unit: item.unit,
      });

      this.searchForIngredient = "";
    },

    remove(index) {
      this.addedIngredients.splice(index, 1);
    },

    getAllBranchIngredient() {
      const params = new URLSearchParams();
      params.append("getAllBranchIngredient", "done");
      params.append("branch_id", this.selectBranch);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.ingredients = response.data.ingredient;
          } else {
            this.ingredients = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranchWithIngredient", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
          } else {
            console.log("no list get");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openDialog() {
      if (this.title == "Add") {
        this.dialog = true;
        this.searchForIngredient = [];
        this.addedIngredients = [];
      } else {
        this.searchForIngredient = [];
        this.addedIngredients = [];
        this.dialog = true;
      }
    },

    dialogAction() {
      this.saveBtnLoading = true;
      if (this.title == "Add") {
        this.saveBtnLoading = false;
        const params = new URLSearchParams();
        params.append("assignModifierIngredient", "done");
        params.append("company_id", this.companyID);
        params.append("branch_id", this.selectBranch);
        params.append(
          "modifierLinkProductList",
          JSON.stringify(this.selectedModifierLinkProducts)
        );
        params.append("ingredientList", JSON.stringify(this.addedIngredients));
        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.dialog = false;
              this.text = "Successfully add";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.saveBtnLoading = false;
              this.getAllModifier();
              this.sendNoticationForSpecificBranch(this.selectBranch);
              this.selectedModifierLinkProducts = [];
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
              this.saveBtnLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.saveBtnLoading = false;
        const params = new URLSearchParams();
        params.append("editModifierIngredient", "done");
        params.append("company_id", this.companyID);
        params.append("branch_id", this.selectBranch);
        params.append("branchLinkModifierId", this.editBranchLinkModifier);
        params.append("ingredientList", JSON.stringify(this.addedIngredients));
        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.dialog = false;
              this.text = "Successfully edit";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.saveBtnLoading = false;
              this.getAllModifier();
              this.sendNoticationForSpecificBranch(this.selectBranch);
              this.selectedModifierLinkProducts = [];
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
              this.saveBtnLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    onExpandedClick(id) {
      this.title = "Edit";
      this.addedIngredients = [];
      this.openDialog();
      this.getIngredientDetail(id);
    },

    getIngredientDetail(branch_link_modifier_id) {
      const params = new URLSearchParams();
      params.append("getIngredientDetailForModifier", "done");
      params.append("branchLinkModifierId", branch_link_modifier_id);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var ingredientDetail = response.data.ingredient;
            this.editBranchLinkModifier = branch_link_modifier_id;
            this.addedIngredients = ingredientDetail;
          } else {
            this.editBranchLinkModifier = branch_link_modifier_id;
            this.addedIngredients = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    sendNotication() {
      for (let i = 0; i < this.branchList.length; i++) {
        const params = new URLSearchParams();
        params.append("send_notification", "done");
        params.append("branch_id", this.branchList[i].branch_id);
        params.append("type", "1");

        axios({
          method: "post",
          url: this.syncDomain + "/sync/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              console.log("Send Notification successfully");
            } else {
              console.log("Send Notification fail");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    sendNoticationForSpecificBranch(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
/* Align checkboxes perfectly under the expand arrow */
.responsive-product-table >>> th.v-data-table__expand-col,
.responsive-product-table >>> td.v-data-table__expand-col {
  width: 48px !important;
  padding: 0 8px !important;
}

/* Cleaner Hover Effects */
.child-row {
  transition: background-color 0.2s;
}
.child-row:hover {
  background-color: #eeeeee !important;
}

.clickable-item {
  cursor: pointer;
}

.clickable-item:hover .branch-name {
  color: #1976d2; /* Primary blue highlight on hover */
}

.transparent-bg {
  background-color: transparent !important;
}

/* Fix for double headers on mobile card view */
.responsive-product-table >>> .v-data-table__mobile-row__header {
  display: none !important;
}
</style>